export const EASY_PEAZY_SUBDOMAIN_BASE = 'easypeazy.site';
export const CHURCHCONNECT_SUBDOMAIN_BASE = 'churchconnect.cloud';
const DEAD_BRAND_BASES = new Set(['easypeazy.cloud']);

/**
 * ChurchConnect complimentary / granted Pro / SSO — not church audience alone.
 * ChurchConnect SSO lands on easypeazy.site/portal; audience=church is also
 * set for EasyPeazy-door churches. Brand-of-arrival wins unless this is the
 * ChurchConnect grant path.
 */
export function isChurchConnectSubdomainPath(client) {
  if (!client) return false;
  const source = String(client.source || '').toLowerCase();
  if (source === 'operate') return false;
  if (source === 'churchconnect') return true;
  if (client.churchconnect_user_id) return true;
  return false;
}

export function liveBrandBase(base) {
  const cleaned = String(base || EASY_PEAZY_SUBDOMAIN_BASE).trim().toLowerCase().replace(/^\./, '');
  if (!cleaned || DEAD_BRAND_BASES.has(cleaned) || cleaned.endsWith('.easypeazy.cloud')) {
    return EASY_PEAZY_SUBDOMAIN_BASE;
  }
  return cleaned;
}

export function subdomainBaseFor(client, brandBase = EASY_PEAZY_SUBDOMAIN_BASE) {
  if (isChurchConnectSubdomainPath(client)) return CHURCHCONNECT_SUBDOMAIN_BASE;
  return liveBrandBase(brandBase);
}
